export const transformPaginatedTestCases = (paginatedData) => {
  if (!paginatedData || !paginatedData[0] || !paginatedData[0].list) {
    return [];
  }

  return paginatedData[0].list.map((item) => {
    const testCase = Object.values(item.testcases)[0];
    return {
      ...testCase,
      TestcaseIndex: item.TestcaseIndex,
    };
  });
};

export const buildSuiteParams = (params) => {
  const searchParams = new URLSearchParams();
  Object.entries(params).forEach(([key, value]) => {
    if (value !== null && value !== undefined) {
      searchParams.set(key, value);
    }
  });
  return searchParams;
};
